module.exports = __webpack_public_path__ + "img/icon_failed.d43d438f.png";